import { createAction } from 'redux-actions';

export const requestHarvestKpiDashboardData = createAction('REQUEST_HARVEST_KPI_DASHBOARD_DATA');
export const receiveHarvestKpiDashboardData = createAction('RECEIVE_HARVEST_KPI_DASHBOARD_DATA');

export const requestBreakdownHarvestKpiDashboardData = createAction('REQUEST_BREAKDOWN_HARVEST_KPI_DASHBOARD_DATA');
export const requestAllHarvestKpiDashboardData = createAction('REQUEST_ALL_HARVEST_KPI_DASHBOARD_DATA');

export const clearHarvestKpiDashboardData = createAction('CLEAR_HARVEST_KPI_DASHBOARD_DATA');
